import TabSimple, { TabItem } from "components/TabSimple";
import DetailInfo from "./DetailInfo";
import * as S from "./style";
import PostTable from "../../Shares/PostTable";
import ContentTable from "../../Shares/ContentTable";
import CommentTable from "../../Shares/CommentTable";
import WalletTable from "./WalletTable";

const tabItems: TabItem[] = [
  {
    id: "wallet",
    title: "MY월렛 이용내역",
    content: <WalletTable />,
  },
  {
    id: "content",
    title: "멤버십 콘텐츠 조회",
    content: <ContentTable />,
  },
  {
    id: "post",
    title: "포스트 작성",
    content: <PostTable />,
  },
  {
    id: "comment",
    title: "댓글 작성",
    content: <CommentTable />,
  },
];

const PremiumDetail: React.FC = () => {
  return (
    <S.Wrapper>
      <S.Heading>
        <h1>멤버십 회원 상세정보</h1>
      </S.Heading>
      <S.Content>
        <DetailInfo />
        <div className="underline" />
        <TabSimple defaultActive="wallet" items={tabItems} />
      </S.Content>
    </S.Wrapper>
  );
};

export default PremiumDetail;
